import * as React from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITable from 'UIComponents/table/UITable';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UITruncateString from 'UIComponents/text/UITruncateString';
import WebhookEditTableHoverCell from 'automation-ui-enrollment/components/eventEnrollment/WebhookEditTableHoverCell';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BorderedTable = styled(UITable).withConfig({
  displayName: "WebhookDefinitionEditPanelPropertiesTable__BorderedTable",
  componentId: "vpj8nm-0"
})(["border-width:0 1px 1px !important;"]);
const WebhookDefinitionEditPanelPropertiesTable = ({
  currentEventProperties,
  stagedEventProperties,
  setPropertyEditIndex
}) => {
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: "300",
    as: "div",
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.eventProperties"
      })
    }), /*#__PURE__*/_jsxs(BorderedTable, {
      condensed: true,
      truncated: true,
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {
          style: {
            textAlign: 'right',
            width: '40%'
          }
        })]
      }), /*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(UITruncateString, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.table.propertyName"
              })
            })
          }), /*#__PURE__*/_jsx("th", {
            style: {
              textAlign: 'right'
            },
            children: /*#__PURE__*/_jsx(UITruncateString, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.table.dataType"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: stagedEventProperties.map((property, index) => /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("td", {
            children: /*#__PURE__*/_jsx(WebhookEditTableHoverCell, {
              propertyLabel: property.label,
              onEditProperty: () => setPropertyEditIndex(index),
              hasChanges: currentEventProperties[index].label !== property.label
            })
          }), /*#__PURE__*/_jsx("td", {
            style: {
              textAlign: 'right'
            },
            children: property.type
          })]
        }, property.propertyName))
      })]
    })]
  });
};
export default WebhookDefinitionEditPanelPropertiesTable;